import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-smart-paragraph',
  templateUrl: './smart-paragraph.component.html',
  styleUrls: ['./smart-paragraph.component.css']
})
export class SmartParagraphComponent implements OnInit {

  @Input() text;
  @Input() limit;

  longText = '';
  shortText = '';

  readMore = false;
  additionalText = '...';

  constructor() { }

  ngOnInit(): void {
    if(!this.text){
      this.text = ''
    }
    if(!this.limit){
      this.limit = 50;
    }
  }

  calculateTexts(){
    if (this.text && this.text.length > 0){
      this.longText = this.text;
      this.shortText = this.text.substr(0, this.limit);
    }
  }

  getTextBuffer(){
    this.calculateTexts();
    if (this.readMore){
      return this.longText;
    } else{
      if(this.text.length>0 && this.text.length > this.limit){
        return this.shortText+'...';
      }else{
        return this.shortText;
      }
    }
  }

}
